import _ from 'lodash';
import { createSelector } from 'reselect';
import { TApplicationState } from '../../libs/store';

const _recruitmentStateSelector = (state: any) => state.recruitment;

/* own profiles */
const _ownProfileStateSelector = createSelector(_recruitmentStateSelector, ({ ownProfiles }) => ownProfiles);

export const ownProfileStatusStateSelector = createSelector(_ownProfileStateSelector, ({ loading, loaded, error }) => ({
  loading,
  loaded,
  error
}));

export const ownProfilesSelector = createSelector(_ownProfileStateSelector, ({ profiles }) => profiles);

/* application */
const _applicationStateSelector = createSelector(_recruitmentStateSelector, ({ application }) => application);
export const profileForApplicationStatusSelector = (profileId: number) =>
  createSelector(_applicationStateSelector, (applicationState) => {
    const { loading, loaded, error } = applicationState[profileId] || {};
    return { loading, loaded, error };
  });

export const profilesForApplicationSelector = (profileId: number) =>
  createSelector(_applicationStateSelector, (appState) => appState[profileId]?.matchingProfiles || []);

export const loadingValidProfilesSelector = createSelector(_applicationStateSelector, (applicationSt) =>
  _.some(_.values(applicationSt), ({ loading }) => loading)
);

export const recruitmentTagSelector = (state: Partial<TApplicationState>) => state.siteMeta?.recruitmentTags;

export const recruitmentFeaturedProfilesSelector = createSelector(
  _recruitmentStateSelector,
  (recruitment) => recruitment.featuredProfiles
);
